export default __webpack_public_path__ + "static/media/fond2.34c4df6b.jpg";